<template>
  <div class="lang-wrapper">
    <!-- 触发按钮 -->
    <div class="lang-trigger hbox" @mouseenter="show = true" @mouseleave="show = false">
      <div style="height: 24px; display: flex; align-items: center; justify-content: center">
        <div :class="'langs-img langs-' + current.lang"></div>
      </div>
      <span>{{ current.text }}</span>
    </div>

    <!-- 下拉面板 -->
    <div class="lang-panel" v-show="show" @mouseenter="show = true" @mouseleave="show = false">
      <div class="lang-box">
        <div class="lang-item" v-for="item in languages" :key="item.lang" :class="{ active: current.lang === item.lang }" @click="onLanguage(item)">
          <span class="lang-flag langs-img" :class="'langs-' + item.lang"></span>
          <span class="lang-name">{{ item.text }}</span>
          <i v-if="current.lang === item.lang" class="fas fa-check"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import languages from '@/utils/languages'
import { setLangauge } from '@/utils/vue-i18n'

export default {
  name: 'LanguageVue',
  data() {
    return {
      current: {},
      languages,
      show: false
    }
  },
  created() {
    this.loadCurrentLang()
  },
  methods: {
    loadCurrentLang() {
      const stored = localStorage.getItem(this.$Const.KEY_LANG)
      if (stored) {
        try {
          this.current = JSON.parse(stored)
          return
        } catch (e) {
          // ignore
        }
      }
      // 默认 English
      this.current = { text: 'English', lang: 'en-us' }
    },

    onLanguage(item) {
      if (this.current.lang === item.lang) {
        this.show = false
        return
      }

      this.current = item
      localStorage.setItem(this.$Const.KEY_LANG, JSON.stringify(item))

      // 切换 i18n
      this.$i18n.locale = item.lang
      setLangauge(item)

      // 刷新页面以应用语言
      location.reload()
    }
  }
}
</script>

<style scoped>
/* ===== 容器 ===== */
.lang-wrapper {
  position: relative;
  display: inline-block;
}

/* ===== 触发按钮 ===== */
.lang-trigger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 0px 10px;
  border-radius: 8px;
  color: #8a949f;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.25s, color 0.25s;
  user-select: none;
}

.lang-trigger:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #e8edf2;
}

.lang-trigger i {
  font-size: 18px;
  color: #e8edf2;
}

.lang-trigger span {
  font-size: 14px;
  color: #8a949f;
}

.lang-trigger:hover span {
  color: #e8edf2;
}

/* ===== 下拉面板 ===== */
.lang-panel {
  position: absolute;
  top: calc(100% + 0px);
  right: 0;
  z-index: 100;
  animation: dropIn 0.2s ease;
  padding-top: 13px;
}

.lang-box {
  min-width: 160px;
  background: #141a20;
  border-radius: 14px;
  border: 1px solid #1e262e;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.7);
  padding: 6px 0;
}

/* ===== 语言项 ===== */
.lang-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 16px;
  color: #b0bcc8;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.lang-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #e8edf2;
}

.lang-item.active {
  color: #e8edf2;
  background: rgba(229, 9, 20, 0.08);
}

.lang-item .lang-name {
  flex: 1;
}

.lang-item .fa-check {
  color: #e50914;
  font-size: 13px;
}

/* ===== 国旗图标（使用 Emoji 或 CSS 背景） ===== */
.lang-flag {
  width: 24px;
  height: 18px;
  border-radius: 3px;
  flex-shrink: 0;
  display: inline-block;
  background-size: cover;
  background-position: center;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* 各国国旗 - 使用 emoji 或背景色方案 */
.flag-en-us {
  background: linear-gradient(135deg, #00247d 33%, #fff 33% 66%, #cf142b 66%);
}
.flag-zh-cn {
  background: linear-gradient(135deg, #de2910 50%, #ffde00 50%);
}
.flag-ja-jp {
  background: #fff;
  position: relative;
}
.flag-ja-jp::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  background: #bc002d;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.flag-ko-kr {
  background: linear-gradient(180deg, #c60c30 50%, #003478 50%);
}
.flag-es-es {
  background: linear-gradient(180deg, #c60b1e 25%, #ffc400 25% 75%, #c60b1e 75%);
}
.flag-fr-fr {
  background: linear-gradient(90deg, #002395 33%, #fff 33% 66%, #ed2939 66%);
}
.flag-de-de {
  background: linear-gradient(180deg, #000 33%, #dd0000 33% 66%, #ffce00 66%);
}
.flag-it-it {
  background: linear-gradient(90deg, #009246 33%, #fff 33% 66%, #ce2b37 66%);
}
.flag-pt-pt {
  background: linear-gradient(90deg, #006600 40%, #ff0000 40% 60%, #006600 60%);
}
.flag-ru-ru {
  background: linear-gradient(180deg, #fff 33%, #0039a6 33% 66%, #d52b1e 66%);
}
.flag-ar-sa {
  background: linear-gradient(180deg, #006c35 40%, #fff 40% 60%, #006c35 60%);
}
.flag-vi-vn {
  background: #da251d;
  position: relative;
}
.flag-vi-vn::after {
  content: '★';
  color: #ffda00;
  font-size: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.flag-th-th {
  background: linear-gradient(180deg, #2d2a4a 20%, #fff 20% 33%, #2d2a4a 33% 66%, #fff 66% 80%, #2d2a4a 80%);
}
.flag-id-id {
  background: linear-gradient(180deg, #ce1126 50%, #fff 50%);
}
.flag-ms-my {
  background: linear-gradient(180deg, #cc0000 50%, #fff 50%);
  position: relative;
}
.flag-ms-my::after {
  content: '☪';
  color: #ffcc00;
  font-size: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.flag-hi-in {
  background: linear-gradient(180deg, #ff9933 33%, #fff 33% 66%, #138808 66%);
  position: relative;
}
.flag-hi-in::after {
  content: '🔄';
  font-size: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.flag-nl-nl {
  background: linear-gradient(180deg, #ae1c28 33%, #fff 33% 66%, #21468b 66%);
}
.flag-sv-se {
  background: #006aa7;
  position: relative;
}
.flag-sv-se::after {
  content: '✚';
  color: #fecc00;
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.flag-pl-pl {
  background: linear-gradient(180deg, #fff 50%, #dc143c 50%);
}
.flag-tr-tr {
  background: #e30a17;
  position: relative;
}
.flag-tr-tr::after {
  content: '☽';
  color: #fff;
  font-size: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ===== 入场动画 ===== */
@keyframes dropIn {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .lang-trigger {
    padding: 2px 6px;
  }
  .lang-trigger i {
    font-size: 15px;
  }
  .lang-trigger span {
    font-size: 14px;
  }
  .lang-panel {
    min-width: 140px;
    right: -8px;
  }
  .lang-item {
    padding: 7px 14px;
    font-size: 13px;
  }
  .lang-flag {
    width: 20px;
    height: 15px;
  }
}

@media (max-width: 480px) {
  .lang-panel {
    min-width: 130px;
    right: -12px;
  }
  .lang-item {
    padding: 6px 12px;
    font-size: 12px;
    gap: 8px;
  }
  .lang-flag {
    width: 18px;
    height: 13px;
  }
}

.hbox {
  height: 46px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
